import React from 'react';
import { CheckIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { teamImage } from '../data/gallery';
export function About() {
  const {
    t
  } = useLanguage();
  return <section id="about" className="bg-white py-20 sm:py-24" data-id="element-21" data-mp="2ts0sjybnt0u4">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8" data-id="element-22" data-mp="2ys5cxzfoufpm">
        <div className="relative" data-id="element-23" data-mp="33rrp05js5pwu">
          <img src={teamImage} alt={t.about.imageAlt} className="aspect-[4/3] w-full rounded-xl object-cover shadow-card" data-id="element-24" data-mp="33qgm07y5sm6s" />
          <dl className="mt-6 grid grid-cols-3 gap-4" data-id="element-25" data-mp="3dgjf085a6054">
            {t.about.stats.map(stat => <div key={stat.label} data-id="element-26" data-mp="3hiwgulgwpdwm">
                <dt className="sr-only" data-id="element-27" data-mp="3hi4t1wtjwkgw">{stat.label}</dt>
                <dd data-id="element-28" data-mp="3mi9d1wto3xbv">
                  <span className="block font-display text-3xl font-extrabold text-navy" data-id="element-29" data-mp="3mj2d6ey4fol1">
                    {stat.value}
                  </span>
                  <span className="mt-1 block text-xs font-medium text-ink/60" data-id="element-30" data-mp="3rehs7a7v7qj1">{stat.label}</span>
                </dd>
              </div>)}
          </dl>
        </div>

        <div data-id="element-31" data-mp="2gqta2nclyu4e">
          <p className="text-sm font-semibold text-brand-blue" data-id="element-32" data-mp="2guh0hdmrb0ew">{t.about.kicker}</p>
          <h2 className="mt-2 font-display text-3xl font-bold leading-tight tracking-tight text-navy sm:text-4xl" data-id="element-33" data-mp="2cqsrcqih7wrj">
            {t.about.title}
          </h2>
          {t.about.body.map(paragraph => <p key={paragraph} className="mt-4 text-base leading-relaxed text-ink/75" data-id="element-34" data-mp="34jt6y5qp8udi">
              {paragraph}
            </p>)}
          <ul className="mt-8 space-y-3" data-id="element-35" data-mp="2vova4nkfkxgw">
            {t.about.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3 text-sm font-medium text-navy" data-id="element-36" data-mp="2qqtukcm7rga6">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-blue/10" data-id="element-37" data-mp="3o5fwmuk7lb1n">
                  <CheckIcon className="h-3.5 w-3.5 text-brand-blue" aria-hidden="true" data-id="element-38" data-mp="3jdy3utscagrr" />
                </span>
                {bullet}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}